import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../MainUrl';
import Header from '../component/layout/Header';
import Footer from '../component/layout/Footer';
import Page from '../component/layout/Page';
import Title from '../component/layout/Title';
import { Row, Col, Card, CardBody, Spinner } from 'reactstrap';
import { notification } from '../component/hocs/notification';
import DataTable from 'react-data-table-component';

const Home = () => {
  const [rawTableData, setRawTableData] = useState([]);
  const [productTableData, setProductTableData] = useState([]);
  const [loadingRaw, setLoadingRaw] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false);

  // Fetch Raw Material Data
  const get_raw_list_handler = () => {
    setLoadingRaw(true);
    axios
      .get(`${mainurl}raw_list`)
      .then((response) => {
        const list = response.data.data.flatMap((row, index) => {
          if (Array.isArray(row?.raw_material_stocks)) {
            const sortedStocks = row.raw_material_stocks.sort((a, b) => a.stock_details_id - b.stock_details_id);
            return sortedStocks.map(stock => ({
              sl: index + 1,
              Raw_Material_Name: row?.raw_material_name ?? 'Unknown',
              Current_Stock_UOM: `${stock.current_stock} ${stock.uom_master?.uom ?? 'N/A'}`,
            }));
          } else {
            console.warn('Missing raw_material_stocks for:', row);
            return [];
          }
        });
        setRawTableData(list);
      })
      .catch((error) => {
        console.error('Error in View Raw API:', error);
        notification('error', 'Failed to fetch raw material data');
      })
      .finally(() => setLoadingRaw(false));
  };

  // Fetch Finished Product Data
  const get_product_list_handler = () => {
    setLoadingProduct(true);
    axios
      .get(`${mainurl}product_list`)
      .then((response) => {
        // Define the UOM mapping based on your provided list
        const uomMapping = {
          1: 'Kilogram',
          2: 'Gram',
          3: 'Pieces',
          4: 'Liter',
          5: 'Milliliter',
        };
  
        const productList = response.data.data.map((product, index) => {
          const uom = uomMapping[product.uom_id] || 'N/A'; // Map uom_id to the UOM name
          return {
            sl: index + 1,
            Product_Name: product.finished_product_name ?? 'Unknown',
            Current_Stock_UOM: `${product.current_stock} ${uom}`, // Show the UOM with stock value
          };
        });
  
        setProductTableData(productList);
      })
      .catch((error) => {
        console.error('Error in View Product API:', error);
        notification('error', 'Failed to fetch product data');
      })
      .finally(() => setLoadingProduct(false));
  };
  

  // Load Data on Component Mount
  useEffect(() => {
    get_raw_list_handler();
    get_product_list_handler();
  }, []);

  // Table Styles
  const custTableStyles = {
    rows: {
      highlightOnHover: true,
      style: { textAlign: 'center' },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000',
        color: 'white',
        textAlign: 'center',
      },
    },
    cells: {
      style: { padding: '10px', textAlign: 'center' },
    },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          {/* Raw Materials Table */}
          <Col xs={12} md={6} className="mb-1">
            <Title pageTitle="Raw Materials List" />
            <Card color="primary" outline>
              <CardBody>
                {loadingRaw ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <DataTable
                    customStyles={custTableStyles}
                    columns={[
                      { name: 'Sl No', selector: (row) => row.sl, width: '80px' },
                      { name: 'Raw Material Name', selector: (row) => row.Raw_Material_Name, wrap: true },
                      { name: 'Current Stock', selector: (row) => row.Current_Stock_UOM, wrap: true },
                    ]}
                    data={rawTableData}
                    keyField="sl"
                   />
                )}
              </CardBody>
            </Card>
          </Col>

          {/* Finished Products Table */}
          <Col xs={12} md={6} className="mb-1">
            <Title pageTitle="Finished Products List" />
            <Card color="primary" outline>
              <CardBody>
                {loadingProduct ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <DataTable
  customStyles={custTableStyles}
  columns={[
    { name: 'Sl No', selector: (row) => row.sl, width: '80px', wrap: true },
    { 
      name: 'Product Name', 
      selector: (row) => (
        <div style={{ display: 'flex', alignItems: 'right' }}>
          <img 
            src={`/product_image/${row.sl}.png`} 
            alt={row.Product_Name} 
            style={{ width: '20px', height: '30px'}} 
          />
          {row.Product_Name}
        </div>
      ), 
      wrap: true 
    },
    { name: 'Current Stock', selector: (row) => row.Current_Stock_UOM, wrap: true, style: { textAlign: 'right', width: '300px' } },
  ]}
  data={productTableData}
  keyField="sl"
  pagination
  paginationPerPage={8} // Show 8 items per page
  paginationRowsPerPageOptions={[8, 16, 24]} // Optional: page size options
/>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default Home;
